import amex from "@/assets/layout/amex.png"
import creditcard1 from "@/assets/layout/creditcard1.png"
import discover from "@/assets/layout/discover.png"
import facebook from "@/assets/layout/facebook.png"
import instagram from "@/assets/layout/instagram.png"
import jcb from "@/assets/layout/jcb.png"
import linkedIn from "@/assets/layout/linkedIn.png"
import mastercard from "@/assets/layout/mastercard.png"
import momo from "@/assets/layout/momo.png"
import paypal from "@/assets/layout/paypal.png"
import pinterest from "@/assets/layout/pinterest1.png"
import tiktok from "@/assets/layout/tiktok.png"
import twitter from "@/assets/layout/twitter.png"
import visa from "@/assets/layout/visa.png"
import youtube from "@/assets/layout/youtube.png"

// 社交媒体列表
export const mediaList = [
	{
		src: instagram,
		// link: "https://www.instagram.com/accounts/login/?next=/popmartglobal/",
		platform: "Instagram",
	},
	{
		src: facebook,
		// link: "https://www.facebook.com/popmartglobal",
		platform: "Facebook",
	},
	{
		src: twitter,
		// link: "https://twitter.com/POPMARTGlobal",
		platform: "X",
	},
	{
		src: youtube,
		// link: "https://www.youtube.com/channel/UCkjDQKykLwCUwAwgP5WKRKg",
		platform: "Youtube",
	},
	{
		src: tiktok,
		// link: "https://www.tiktok.com/@popmartglobal",
		platform: "TikTok",
	},
	{
		src: linkedIn,
		// link: "https://www.linkedin.com/company/pop-mart",
		platform: "LinkedIn",
	},
	{
		src: pinterest,
		// link: "https://www.pinterest.com/popmart_online_stores/",
		platform: "Pinterest",
	},
]

// 支付方式列表
export const creditCardList = [
	{
		src: visa,
		link: "",
		method: "VISA",
	},
	{
		src: mastercard,
		link: "",
		method: "MASTER",
	},
	{
		src: amex,
		link: "",
		method: "AMEX",
	},
	{
		src: discover,
		link: "",
		method: "DISCOVERY",
	},
	{
		src: jcb,
		link: "",
		method: "JCB",
	},
	{
		src: creditcard1,
		link: "",
		method: "CREDITCARD",
	},
	{
		src: paypal,
		link: "",
		method: "PAYPAL",
	},
	{
		src: momo,
		link: "",
		method: "MOMO",
	},
]

export const helpLinks = [
	{ label: "FAQs", href: "/faqs" },
	{ label: "Terms & Conditions", href: "/terms" },
	{ label: "Privacy Policy", href: "/privacy" },
	{ label: "Shipping Policy", href: "/shipping" },
	{ label: "Returns & Refunds", href: "/returns" },
	{ label: "Track your order", href: "/order" },
	{ label: "Order Status", href: "/status" },
]

export const infoLinks = [
	{ label: "Store", href: "/contact" },
	{ label: "About us", href: "/about-us" },
	{ label: "Investor Relations", href: "/investor" },
	{ label: "Contact us", href: "/contact" },
	{ label: "Global Ambassador", href: "/ambassador" },
	{ label: "News", href: "/news" },
	{ label: "Stamps Event", href: "/event" },
]

export const productLinks = [
	{ label: "All Blind Box", href: "/blind-box" },
	{ label: "All Figures", href: "/figures" },
	{ label: "Accessories", href: "/accessories" },
]

// 订阅信息 - 使用翻译 key
export const communityInfo = {
	title: "footer.community.title",
	description: "footer.community.description",
	placeholder: "footer.community.placeholder",
	signUp: "footer.community.signUp",
}

// 联系信息 - 使用翻译 key
export const contactInfo = {
	title: "footer.contact.title",
	chatTitle: "footer.contact.chatTitle",
	chatDescription: "footer.contact.chatDescription",
	chatButton: "footer.contact.chatButton",
	emailTitle: "footer.contact.emailTitle",
	emailDescription: "footer.contact.emailDescription",
	emailButton: "footer.contact.emailButton",
	helpCenter: "footer.contact.helpCenter",
}

// 页脚版权信息 - 使用翻译 key
export const copyrightInfo = {
	text: "footer.copyright",
}

// 地区和语言设置
export const regionSettings = {
	region: { emoji: "🇭🇰", text: "HK" },
	language: "中文(繁體)",
}
